import React from "react";
import { BookOpen } from "lucide-react";

export default function CheatSheetTab({ cert }) {
  if (!cert) return null;
  return (
    <div className="space-y-5" data-testid="cheat-sheet-tab">
      {cert.cheat_sheet.map((section) => (
        <div key={section.section} className="glass-panel rounded-2xl p-6" data-testid={`cheat-sheet-section-${section.section}`}>
          <div className="flex items-center gap-2 mb-3">
            <BookOpen className="w-4 h-4 text-indigo-400" />
            <h3 className="font-heading text-base font-semibold text-white">{section.section}</h3>
          </div>
          <ul className="space-y-2">
            {section.points.map((p) => (
              <li key={p} className="flex items-start gap-2 text-sm text-slate-300 leading-relaxed">
                <span className="w-1.5 h-1.5 rounded-full bg-indigo-400 mt-2 shrink-0" /> {p}
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
}
